var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-setting-items",
      attrs: { id: "product_setting_items" }
    },
    [
      _c(
        "div",
        { staticClass: "product-setting-items__title" },
        [
          _c("span", { staticClass: "text" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("__product_setting.title")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "v-icon",
            {
              staticClass: "close_24px",
              attrs: { color: "white" },
              on: { click: _vm.close_product_setting_dialog }
            },
            [_vm._v("\n            icon-close\n        ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "draggable-item",
          attrs: { handle: ".handle" },
          on: {
            change: function($event) {
              return _vm.change_order(_vm.order_name_list, $event.moved)
            }
          },
          model: {
            value: _vm.mutable_product_setting_items,
            callback: function($$v) {
              _vm.mutable_product_setting_items = $$v
            },
            expression: "mutable_product_setting_items"
          }
        },
        _vm._l(_vm.mutable_product_setting_items, function(item, key) {
          return _c(
            "div",
            {
              key: key,
              attrs: {
                title: _vm.$t("__product_setting.draggable_tooltip_text")
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "product-setting-item",
                  class: {
                    "empty-wrapper": item.is_on_map === false
                  }
                },
                [
                  item.is_on_map && !_vm.judge_empty_data(item.tag_config)
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "product-setting-content__title d-flex align-center justify-space-between"
                          },
                          [
                            _c("div", { staticClass: "d-flex align-center" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "product-setting-content__visibility-btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggle_visibility(
                                        item.name,
                                        item.visibility_by_user
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "svg-icon",
                                      attrs: {
                                        color: item.visibility_by_user
                                          ? "white"
                                          : "grey"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    icon-visibility\n                                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.text))])
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-icon",
                              {
                                staticClass: "handle svg-icon",
                                attrs: { color: "#b3b7c4" }
                              },
                              [
                                _vm._v(
                                  "\n                            icon-move\n                        "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          item.name === _vm.radar_id
                            ? _c(
                                "div",
                                {
                                  staticClass: "product-setting-content__item"
                                },
                                [_c("RadarControl")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          ["station", "auto", "gauge"].includes(item.sub_type)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "gis-slider product-setting-content__item"
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "gis-slider__title" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("__product_setting.map_zoom")
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-slider", {
                                    attrs: {
                                      step: "1",
                                      ticks: "",
                                      max:
                                        _vm.all_map_config.map.options.maxZoom,
                                      min:
                                        _vm.all_map_config.map.options.minZoom,
                                      "tick-labels": _vm.get_gis_slider_labels(
                                        _vm.all_map_config,
                                        item.sub_type
                                      )
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend",
                                          fn: function() {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "gis-slider__hint-text"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "__product_setting.least"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "append",
                                          fn: function() {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "gis-slider__hint-text"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "__product_setting.largest"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.zoom_level,
                                      callback: function($$v) {
                                        _vm.zoom_level = $$v
                                      },
                                      expression: "zoom_level"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.tag_config && item.tag_config.initial_time_list
                            ? _c("div", {
                                staticClass:
                                  "forecast-text product-setting-content__item",
                                domProps: {
                                  innerHTML: _vm._s(_vm.get_forecast_text(item))
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.tag_config && item.tag_config.vertical
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "control-btn product-setting-content__item"
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "control-btn__content",
                                      on: {
                                        click: function($event) {
                                          return _vm.set_is_open_vertical_radar(
                                            !_vm.is_open_vertical_radar
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "control_btn waves-effect",
                                          class: {
                                            "control-btn__item--active":
                                              _vm.is_open_vertical_radar
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    自訂"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                    剖面\n                                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.sub_type === "alert"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "control-switch product-setting-content__item"
                                },
                                [
                                  _vm._v(
                                    "\n                            顯示" +
                                      _vm._s(item.text) +
                                      "\n                            "
                                  ),
                                  _c("v-switch", {
                                    staticClass: "control-switch__item",
                                    attrs: { dense: "" },
                                    model: {
                                      value: _vm.is_show_alert_table,
                                      callback: function($$v) {
                                        _vm.is_show_alert_table = $$v
                                      },
                                      expression: "is_show_alert_table"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.sub_type === "ty_track"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "control-btn product-setting-content__item",
                                  class: {
                                    "control-btn--en": _vm.language === "en"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "control-btn__content",
                                      on: {
                                        click: _vm.toggle_typhoon_time_display
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "control-btn__item waves-effect waves-light",
                                          class: {
                                            "control-btn__item--active":
                                              _vm.is_show_typhoon_time
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "__geojson.typhoon_route"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t("__geojson.typhoon_time")
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "control-btn__content",
                                      on: {
                                        click: _vm.toggle_typhoon_animation
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "control-btn__item waves-effect waves-light",
                                          class: {
                                            "control-btn__item--active":
                                              _vm.is_show_typhoon_animation
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "__geojson.typhoon_route"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "__geojson.typhoon_animation"
                                                )
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.accumlated_precp_id_list.includes(item.name)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "control-switch product-setting-content__item"
                                },
                                [
                                  _vm._v(
                                    "\n                            顯示" +
                                      _vm._s(item.text) +
                                      "表格\n                            "
                                  ),
                                  _c("v-switch", {
                                    staticClass: "control-switch__item",
                                    attrs: { dense: "" },
                                    model: {
                                      value:
                                        _vm.is_show_accumulated_precp_table,
                                      callback: function($$v) {
                                        _vm.is_show_accumulated_precp_table = $$v
                                      },
                                      expression:
                                        "is_show_accumulated_precp_table"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.sub_type === "dropsonde"
                            ? _c(
                                "div",
                                {
                                  staticClass: "product-setting-content__item"
                                },
                                [_c("hPaControl")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.set_val[item.name]
                            ? _c(
                                "div",
                                {
                                  staticClass: "product-setting-content__item"
                                },
                                [
                                  _c("span", { staticClass: "small-text" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t("__product_setting.opacity")
                                        ) +
                                        "： " +
                                        _vm._s(_vm.set_val[item.name] * 100) +
                                        "%\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "menu-range" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.set_val[item.name],
                                          expression: "set_val[item.name]"
                                        }
                                      ],
                                      attrs: {
                                        name: "name",
                                        type: "range",
                                        min: "0",
                                        max: "1",
                                        step: "0.1"
                                      },
                                      domProps: {
                                        value: _vm.set_val[item.name]
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.change_opacity(
                                            item.name,
                                            $event.target.value
                                          )
                                        },
                                        __r: function($event) {
                                          return _vm.$set(
                                            _vm.set_val,
                                            item.name,
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.tag_config && item.tag_config.toggle_tooltip_btn
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "control-switch product-setting-content__item"
                                },
                                [
                                  _vm._v(
                                    "\n                            顯示" +
                                      _vm._s(item.text) +
                                      "\n                            "
                                  ),
                                  _c("v-switch", {
                                    staticClass: "control-switch__item",
                                    attrs: { dense: "" },
                                    on: {
                                      change: function($event) {
                                        return _vm.toggle_monitor_tooltip(item)
                                      }
                                    },
                                    model: {
                                      value: _vm.is_show_monitor_tooltip,
                                      callback: function($$v) {
                                        _vm.is_show_monitor_tooltip = $$v
                                      },
                                      expression: "is_show_monitor_tooltip"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.sub_type === "lightning_alert"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "control-switch product-setting-content__item"
                                },
                                [
                                  _vm._v(
                                    "\n                            顯示" +
                                      _vm._s(item.text) +
                                      "\n                            "
                                  ),
                                  _c("v-switch", {
                                    staticClass: "control-switch__item",
                                    attrs: { dense: "" },
                                    model: {
                                      value: _vm.is_show_alert_table,
                                      callback: function($$v) {
                                        _vm.is_show_alert_table = $$v
                                      },
                                      expression: "is_show_alert_table"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]
                    : item.is_on_map === false ||
                      _vm.judge_empty_data(item.tag_config)
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "product-setting-content__title d-flex align-center justify-space-between"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "svg-icon",
                                      attrs: { color: "white" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                icon-play-cloud-off\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    item.is_on_map &&
                                    _vm.judge_empty_data(item.tag_config)
                                      ? _c(
                                          "div",
                                          { staticClass: "small-text" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  item.tag_config.data_empty
                                                    .text
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      : item.tag_config.no_data === "pink"
                                        ? _c(
                                            "div",
                                            { staticClass: "small-text" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "__product_setting.no_release"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        : item.information.length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "small-text" },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "__product_setting.fix"
                                                      )
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "small-text" },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "__product_setting.no_data"
                                                      )
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(item.text) +
                                          "\n                                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.accumlated_precp_id_list.includes(
                                      item.name
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "control-switch" },
                                          [
                                            _vm._v(
                                              "\n                                    顯示" +
                                                _vm._s(item.text) +
                                                "表格\n                                    "
                                            ),
                                            _c("v-switch", {
                                              staticClass:
                                                "control-switch__item",
                                              attrs: { dense: "" },
                                              model: {
                                                value:
                                                  _vm.is_show_accumulated_precp_table,
                                                callback: function($$v) {
                                                  _vm.is_show_accumulated_precp_table = $$v
                                                },
                                                expression:
                                                  "is_show_accumulated_precp_table"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              item.information && item.information.length > 0
                                ? _c(
                                    "div",
                                    [
                                      _c("InformationTooltip", {
                                        attrs: { information: item.information }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass:
                                "product-setting-content__title d-flex align-center justify-space-between"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "svg-icon",
                                      attrs: { color: "white" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                icon-visibility\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.text))])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "handle svg-icon",
                                  attrs: { color: "#b3b7c4" }
                                },
                                [
                                  _vm._v(
                                    "\n                            icon-move\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                ],
                2
              )
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }